<template>
  <div v-if="item">
    <h6 class="mb-0 check-text-center">
      {{ item.name }}
    </h6>
    <h6
      class="legends worksansr mb-0 check-text-center"
      v-for="stocked_item in item.stocked_item"
      :key="stocked_item.id"
    >
      QUANTIDADE EM ESTOQUE:
      <strong>
        {{ stocked_item.total }}
        {{ item.unit_of_measurement_abbreviation }}
      </strong>
      - {{ stocked_item.stock_group_name }}
      <div
        v-if="
          stocked_item.defeated &&
          stocked_item.defeated.total &&
          stocked_item.defeated.total > 0
        "
        class="c-danger mt-2"
      >
        <strong>
          EXISTE {{ stocked_item.defeated.total }}
          {{ item.unit_of_measurement_abbreviation }}
          VENCIDO(S)
        </strong>
        <v-btn
          class="btn-add-down"
          x-small
          @click="handleToLot(item)"
        >
          <i class="fas fa-link mr-1"></i> ACESSAR LOTE</v-btn
        >
      </div>
    </h6>
  </div>
</template>

<script>
import routes from "../../../../routes";

export default {
  name: "ProductInformation",

  props: {
    item: { type: Object },
    resident_id: { type: String },
  },

  methods: {
    handleToLot(product) {
      let { resident_id } = this;
      routes.push({
        name: "new-stock",
        query: {
          menu: "items",
          tipo: "lots",
          s: product.name,
          resident_id,
          is_product: true
        },
      });
    },
  },
};
</script>
